export default {
  // Admin - Customers List
  'admin.customers.title': '고객 관리',
  'admin.customers.subtitle': '등록된 고객 및 계정을 관리합니다',
  'admin.customers.search': '고객 검색...',
  'admin.customers.filter.all': '전체',
  'admin.customers.filter.customer': '고객',
  'admin.customers.filter.admin': '관리자',
  'admin.customers.filter.superAdmin': '최고 관리자',
  'admin.customers.columns.name': '이름',
  'admin.customers.columns.email': '이메일',
  'admin.customers.columns.company': '회사',
  'admin.customers.columns.country': '국가',
  'admin.customers.columns.role': '역할',
  'admin.customers.columns.joined': '가입일',
  'admin.customers.columns.status': '상태',
  'admin.customers.columns.actions': '작업',
  'admin.customers.status.active': '활성',
  'admin.customers.status.inactive': '비활성',
  'admin.customers.noResults': '고객을 찾을 수 없습니다',
  'admin.customers.total': '{{count}}명의 고객',
  'admin.customers.viewDetail': '상세 보기',

  // Admin - Customer Detail
  'admin.customerDetail.back': '고객 목록으로 돌아가기',
  'admin.customerDetail.title': '고객 상세 정보',
  'admin.customerDetail.profile': '프로필',
  'admin.customerDetail.company': '회사 정보',
  'admin.customerDetail.addresses': '주소',
  'admin.customerDetail.quotations': '견적 요청',
  'admin.customerDetail.orders': '주문',
  'admin.customerDetail.aiPreviews': 'AI 프리뷰',
  'admin.customerDetail.noCompany': '등록된 회사 없음',
  'admin.customerDetail.noAddresses': '등록된 주소 없음',
  'admin.customerDetail.noQuotations': '견적 요청 내역 없음',
  'admin.customerDetail.noOrders': '주문 내역 없음',
  'admin.customerDetail.noPreviews': 'AI 프리뷰 내역 없음',
  'admin.customerDetail.roleChange': '역할 변경',
  'admin.customerDetail.roleChangeHint': '최고 관리자만 역할을 변경할 수 있습니다',
  'admin.customerDetail.save': '변경 저장',
  'admin.customerDetail.basicInfo': '기본 정보',
  'admin.customerDetail.contactInfo': '연락처 정보',
};